<template>
  <ContainerPrice>
    <template #default="{ price, product, selectedOffer }">
      <Price :price :product :selected-offer />
    </template>
  </ContainerPrice>
</template>

<script lang="ts" setup>
import ContainerPrice from '~/scopes/product-core/components/containers/ContainerPrice/ContainerPrice.vue'
import Price from '~/scopes/product-core/pages/ProductDetailPage/jp/components/JPContainerPrice/components/Price/Price.vue'
</script>
